const DaanVazhakkala=[
    
{
      src: 'https://i.postimg.cc/NMq1h0G3/ABI1677-HDR-Edit-1.jpg',
      alt: 'Daan Inn Vazhakkala',
    },
    {
      src: 'https://i.postimg.cc/dVhdLChM/ABI1701-HDR-Edit.jpg',
    alt: 'Daan Inn Vazhakkala',
    },
    {
      src: 'https://i.postimg.cc/qRx69X5K/ABI1707-HDR-Edit.jpg',
 alt: 'Daan Inn Vazhakkala',    },
    {
      src: 'https://i.postimg.cc/43zY9QZ0/ABI1719-HDR-Edit.jpg',
 alt: 'Daan Inn Vazhakkala',    },
    {
      src: 'https://i.postimg.cc/y6fkcd47/ABI1545-HDR-Edit.jpg',
 alt: 'Daan Inn Vazhakkala',    }, {
      src: 'https://i.postimg.cc/ncgrSPh5/ABI1515-HDR-Edit.jpg',
   alt: 'Daan Inn Vazhakkala',
    }, {
      src: 'https://i.postimg.cc/6QN3t4Rf/ABI1434-HDR-Edit.jpg',
    alt: 'Daan Inn Vazhakkala',
    }, {
      src: 'https://i.postimg.cc/VNBN6sWQ/ABI1458-HDR-Edit.jpg',
      alt: 'Daan Inn Vazhakkala',
    }, {
      src: 'https://i.postimg.cc/j5xSJVMW/ABI1446-HDR-Edit.jpg',
 alt: 'Daan Inn Vazhakkala',
    },{
      src: 'https://i.postimg.cc/TwtYVkst/ABI1389-HDR-Edit.jpg',
      alt: 'Daan Inn Vazhakkala',
    },{
      src: 'https://i.postimg.cc/Y0j2b6KM/ABI1380-HDR-Edit.jpg',
 alt: 'Daan Inn Vazhakkala',
    },
    {
      src: 'https://i.postimg.cc/5yG4GXbv/ABI1614-HDR-Edit.jpg',
 alt: 'Daan Inn Vazhakkala',
    },

]

export default DaanVazhakkala;